import { INTEGRATION_LEVEL_TYPE } from '../constants/IntegrationConstants';

/**
 * Add the given integration to the correct path in the integration map
 *
 * @param {*} integrationMap
 * @param {*} integrationType
 * @param {*} type
 * @param {*} vendor
 * @param {*} integration
 * @returns
 */
export const appendIntegrationToIntegrationMap = (
  integrationMap,
  integrationType,
  type,
  vendor,
  integration
) => {
  const newIntegration = {
    [integrationType]: {
      ...(integrationMap?.[integrationType] || {}),
      [type]: {
        ...(integrationMap?.[integrationType]?.[type] || {}),
        [vendor]: integration,
      },
    },
  };
  return Object.assign(integrationMap || {}, newIntegration);
};

/**
 * Generates integration map
 * Integration map has 3 levels
 * Integration type : user, tenant
 * Type: CRM, Comunication etc..
 * Vendor: Hubspot, Gmail etc..
 *
 * @param {*} integrations
 * @returns
 */
export const generateIntegrationMap = (integrations) => {
  return integrations.reduce((integrationMap, integration) => {
    return appendIntegrationToIntegrationMap(
      { ...integrationMap },
      INTEGRATION_LEVEL_TYPE[integration.entity],
      integration.type,
      integration.vendor,
      { ...integration }
    );
  }, {});
};
